import flex from 'styles/flex';

export const cond = (condition, rule) => (condition ? rule : '');

export const withoutLast = (rule, lastRule) => `
  ${rule}

  &:last-child {
    ${lastRule}
  }
`;

export const withoutLastOfType = (rule, lastRule) => `
  ${rule}

  &:last-of-type{
    ${lastRule}
  }
`;

export const oneOf = (prop, obj) => `${obj[prop]};`;

export const placeholder = style => `
  &::-webkit-input-placeholder {
   ${style}
  }

  &:-moz-placeholder {
    ${style}
  }

  &::-moz-placeholder {
    ${style}
  }

  &:-ms-input-placeholder {
    ${style}
  }
`;

export const noSelect = `
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

export const proportional = (p = 1) => `
  &:after {
    content: "";
    display: block;
    padding-bottom: ${p * 100}%;
  }
`;

export const absoulteFull = `
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
`;

export const whenHovering = (className, rule) => `
  &:hover {
    .${className} {
      ${rule}
    }
  }
`;

export const showOnHover = className => whenHovering(className, 'opacity: 1;');
export const displayOnHover = (className, display = 'flex') =>
  whenHovering(className, `display: ${display} !important;`);

export const ellipsis = `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// Truncates long words, but preserves lines
export const ellipsisWrap = `
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const iconSize = (iconSz, fontSize = size) => `
  font-size: ${fontSize}px !important;
  height: ${iconSz}px;
  width: ${iconSz}px;
`;

export const line = (color = 'gray', lineHeight = 1) => `
  height: ${lineHeight}px;
  border: none;
  background-color: ${color};
`;

export const size = sizePx => `
  width: ${sizePx}px;
  height: ${sizePx}px;
`;

export const minSize = sizePx => `
  min-width: ${sizePx}px;
  min-height: ${sizePx}px;
`;

export const circle = circleSize => `
    border-radius: 100%;
    text-align: center;
    ${flex.horizontal}
    ${flex.centerHorizontal}
    ${size(circleSize)}
    ${minSize(circleSize)}
    line-height: ${circleSize}px;
`;

export const scrollbars = `
  overflow: auto;
  -webkit-overflow-scrolling: touch
`;

export const visuallyHidden = `
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
